import { CHOOSE_PAYMENT } from "@hopper-b2b/types";
import { trackBaseEvent } from "../utils";

export const trackChoosePaymentMethod = async (context) =>
  trackBaseEvent(context, {
    eventName: CHOOSE_PAYMENT,
    properties: {},
  });
